import { useNavigate } from 'react-router-dom'
import { usePostQuery } from 'hooks'
import { Card, Title } from 'components'
import { DungeonAdminForm } from './form'

export const AdminDungeonNew = () => {
  const navigate = useNavigate()
  const { post: createDungeon } = usePostQuery({ url: '/admin/dungeons' })

  const handleSubmit = async (data) => {
    const res = await createDungeon(data)
    if (res?.dungeon?.id) navigate('/admin/dungeons')
  }

  return (
    <Card margin="0.5rem">
      <Title level={3} color="link">New Dungeon</Title>
      <DungeonAdminForm onSubmit={handleSubmit} submitLabel="Create Dungeon" />
    </Card>
  )
}
